module.exports = __webpack_public_path__ + "static/media/0-8.7e832217.svg";